import React from 'react';

declare global {
  interface Window {
    __lastError?: {
      error: unknown;
      errorInfo: React.ErrorInfo;
    };
  }
}

type ErrorBoundaryProps = {
  children: React.ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
  message?: string;
};

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    const msg = error instanceof Error ? error.message : String(error);
    return { hasError: true, message: msg };
  }

  componentDidCatch(error: unknown, errorInfo: React.ErrorInfo) {
    if (typeof window === 'undefined') {
      return;
    }

    // Expose last error on window for optional inspection via DevTools Console
    window.__lastError = { error, errorInfo };
  }

  render() {
    if (this.state.hasError) {
      // Keep UI minimal; logging happens in console. Avoid rendering complex UI here to prevent loops.
      return null;
    }
    return this.props.children as React.ReactElement;
  }
}
